export const CONTACT_EMAIL = "kontakt@amazing.wedding";
export const CONTACT_EMAIL_MAILTO = `mailto:${CONTACT_EMAIL}`;
export const INSTAGRAM_URL = "https://www.instagram.com/amazing_wedding_app/";
